import axios from 'axios'

export default{
  namespaced: true,
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    getEventCountByPropertyReport ({commit, state, rootState}) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/reports/eventCountByProperty`)
      try {
        return axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/reports/eventCountByProperty`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    getInsuranceClaimReport ({commit, state, rootState}, args) {
      let apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/reports/insuranceClaim`
      console.log(apiPath, args)
      try {
        return axios.get(apiPath, {params: {claimDateOnOrBefore: args.claimDateOnOrBefore, claimDateOnOrAfter: args.claimDateOnOrAfter}})
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    getInsuranceClaimDateRange ({commit, state, rootState}) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/reports/insuranceClaimDateRange`)
      try {
        return axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/reports/insuranceClaimDateRange`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    }
  }
}
